import React, { Component } from 'react'
import { connect } from 'react-redux'
import {delay} from '../Animations/helper'

class StartingLineupWindow extends Component {

    static propTypes = {

    }

    static defaultProps = {

    }

    constructor(props) {
        super(props);
        this.Hidden = true;
        this.Settings = window.ModalSettings;
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
    }

    handleClick(event){
        this.hide();
    }

    hide() {
        if(this.Settings.ShowStartingLineup)
            this.window.classList.add("hideSlow");
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.currentEvent != this.props.currentEvent && nextProps.currentEvent === 1) {
            this.Hidden = false;
            this.forceUpdate();
        }

        if(nextProps.currentEvent != this.props.currentEvent && nextProps.currentEvent > 1 && this.Hidden === false) {
            this.hide();
        }

        if(this.props.currentEvent > 2) {
            this.Hidden = true;
            this.forceUpdate();
        }
      }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    render() {        
        if(this.Hidden == true || this.Settings.ShowStartingLineup === false)
            return null;
        
        return (<div ref={(ref) => this.window = ref} className="starting-lineup" onClick={this.handleClick}>
                    <div className="row header">
                        <div className="col-md-5 col-sm-5 home showFromLeft">
                             <div className="teamName">{this.props.home.Name}</div>
                             <div className="manager">{this.props.home.manager.name}</div>
                        </div>
                        <div className="col-md-2 col-sm-2">
                        
                        </div>
                        <div className="col-md-5 col-sm-5 away showFromRight">
                            <div className="teamName">{this.props.away.Name}</div>
                             <div className="manager">{this.props.away.manager.name}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-5 col-sm-5 home">
                            {this.props.home.Players.slice(0,11).map((player, i) =>
                                <div key={player.Id} className="player row showFromLeft">
                                    <div className="col-md-10 col-sm-10 name">{player.Name.LastName} {player.captain === true ? "(к)" : ""}</div>
                                    <div className="col-md-2 col-sm-2 number">{player.Number}</div>
                                </div>
                            )}
                        </div>
                        <div className="col-md-2 col-sm-2">
                        
                        </div>
                        <div className="col-md-5 col-sm-5 away">
                            {this.props.away.Players.slice(0,11).map((player, i) =>
                                <div key={player.Id} className="player row showFromRight">
                                    <div className="col-md-2 col-sm-2 number">{player.Number}</div>
                                    <div className="col-md-10 col-sm-10 name">{player.Name.LastName} {player.captain === true ? "(к)" : ""}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        home: state.HomeTeam,
        away: state.AwayTeam,
        currentEvent: state.currentEvent
    };
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StartingLineupWindow)



/** WEBPACK FOOTER **
 ** ./src/components/Info/StartingLineupWindow.js
 **/